export default "__VITE_ASSET__BZbcot1z__"